// --- from UserAccess.ts ---
import type { Shop } from '@features/shop';
import type { Warehouse } from '@features/warehouse';

export interface UserAccess {
  name?: string;
  admin?: boolean;
  debug?: boolean;
  shipmentBoxEnabled?: boolean;
  adminUrl?: string;
  shops?: Shop[];
  warehouse?: Warehouse;
}

// --- from UserLogin.ts ---
export interface UserLogin {
  username?: string;
  password?: string;
  ip?: string;
}

// --- from Token.ts ---
export interface Token {
  token?: string | null;
}

// --- from RoleEnum.ts ---
export enum Role {
  Info = 'INFO',
  Picking = 'PICKING',
  PickingSession = 'PICKING_SESSION',
  Rebut = 'REBUT',
  Reception = 'RECEPTION',
  Print = 'REPRINT',
  ReturnProduct = 'RETURN_PRODUCT',
  Shipping = 'SHIPPING',
  Inventory = 'INVENTORY',
  Transfer = 'TRANSFER',
  Barcode = 'BARCODE',
  IncomingParcelScan = 'INCOMING_PARCEL_SCAN',
  Workshop = 'WORKSHOP',
}
